export default __webpack_public_path__ + "static/media/r1.a88d7850.jpg";